import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface NoResultsData {
  searchTerm: string;
  clearSearch: () => void;
}

const truncateSearchTerm = (searchTerm: string) =>
  searchTerm.length > 30 ? `${searchTerm.substring(0, 30)}...` : searchTerm;

const NoResultsTableFilter = ({ searchTerm, clearSearch }: NoResultsData) => {
  const { t } = useTranslation("common");
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        justifyContent: "center",
        margin: "190px",
      }}
      data-testid="no-search-results"
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            textAlign: "center",
          }}
          component="p"
          variant="h2"
          data-testid="no-search-results-found-title"
        >
          {`${t("table.globalSearch.noResults.title")} "${truncateSearchTerm(
            searchTerm.trim()
          )}"`}
        </Typography>
        <Typography
          sx={{ margin: "12px" }}
          data-testid="no-search-results-found-subtitle"
        >
          {t("table.globalSearch.noResults.subTitle")}
        </Typography>
        <Button
          data-testid="clearFilterButton"
          variant="primary"
          onClick={clearSearch}
          sx={{ width: "140px" }}
        >
          {t("table.globalSearch.clearFilter")}
        </Button>
      </Box>
    </Box>
  );
};

export default NoResultsTableFilter;
